// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7p0h4","col":"styles_col__1Dfj1"};